import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {NGXLogger} from 'ngx-logger';
import {Observable, of as observableOf} from 'rxjs';

import {tap} from 'rxjs/operators';
import {SessionService} from '../../../shared/service/session.service';

import {Sensor} from '../model/sensor.model';
import {SensorService} from '../service/sensor.service';

@Injectable()
export class SensorResolver {

  constructor(private logger: NGXLogger, private sessionService: SessionService, private sensorDataService: SensorService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Sensor> {
    this.logger.debug('SensorResolver: Waiting for sensor data to be available.');

    const sensorId = this.getSensorId(route);
    if (this.isCurrentSensorIdEqualsToSensorId(sensorId)) {
      return observableOf(this.sessionService.getCurrentSensor());
    }

    return this.sensorDataService.getSensor(sensorId).pipe(tap((sensor) => {
        this.sessionService.updateSharedSensor(sensor);

        return sensor;
      }
    ));
  }

  private getSensorId(route: ActivatedRouteSnapshot): string {
    if (route.params['id']) {
      return route.params['id'];
    } else {
      return route.parent.params['id'];
    }
  }

  private isCurrentSensorIdEqualsToSensorId(sensorId: string): boolean {
    return this.sessionService.getCurrentSensor() &&
      this.sessionService.getCurrentSensor().id === sensorId;
  }
}
